import {SureFlowLoopDetail} from './sure-flow-loop-detail';

export class SureFlowAutoSelectInput {

  loopId!: number;
  cooling!: boolean;
  loopDetail!: SureFlowLoopDetail;
  sensibleTarget!: boolean;
  selectedUnitIds!: number[];

}
